import { render, staticRenderFns } from "./MessageDelete.vue?vue&type=template&id=12dfe5d0"
import script from "./MessageDelete.vue?vue&type=script&lang=js"
export * from "./MessageDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports